import {Injectable} from "@angular/core";
import {BaseService} from "@core/service/base.service";
import {HttpClient} from '@angular/common/http';
import {catchError, tap} from "rxjs/operators";


@Injectable({providedIn: 'root'})
export class DynamicFormValueService extends BaseService {

  private url = 'api/dynamic-form-value';  // URL to web api

  constructor(http: HttpClient) {
    super(http);
  }

  getUrl(): string {
    return this.url;
  }

  /**
   * 根据动态表单code、业务类型、业务id获取值
   * @param code 动态表单code
   * @param bizType 业务类型
   * @param bizId 业务id
   */
  getByCodeAndBizTypeAndBizId(code:string,bizType:string,bizId:string):any{
    const url = `${this.getUrl()}/${code}/${bizType}/${bizId}`;
    return this.http.get<any>(url).pipe(
      tap(() => this.log(`fetched object code=${code} bizType=${bizType} bizId=${bizId}`)),
      catchError(this.handleError<any>(`get any code=${code} bizType=${bizType} bizId=${bizId}`))
    );
  }

}

